import { useEffect } from 'react'
import { usePrototypeState } from '@sketch-hq/sketch-web-renderer'
import { useReplaceUrl } from './useReplaceUrl'

/**
 * Update the url when the current Artboard changes, i.e. when the user
 * navigates between Screens.
 */
export function useSyncUrl() {
  const { currentArtboardId } = usePrototypeState()
  const replace = useReplaceUrl()

  useEffect(() => {
    if (!currentArtboardId) return
    replace({ currentArtboardUUID: currentArtboardId })
  }, [currentArtboardId, replace])
}
